<template>
  <div class="counter-row">
    <span class="counter" :class="{over: isOverLimit}">{{ charCount }}/{{ maxLength }}</span>
  </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  value: {type: String, default: ""},
  count: {type: Number, default: null}, // rendered-text length from the editor, when given
  maxLength: {type: Number, required: true},
});

const charCount = computed(() => {
  if (props.count !== null) return props.count;
  return (props.value || "").replace(/<[^>]*>/g, "").length;
});
const isOverLimit = computed(() => charCount.value > props.maxLength);
</script>

<style scoped>
.counter-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 3px;
}
.counter {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
}
.counter.over {
  color: #dc2204;
  font-weight: 600;
}
</style>
